import { render, staticRenderFns } from "./GroupMemberBar.vue?vue&type=template&id=7d8268a4&scoped=true"
import script from "./GroupMemberBar.vue?vue&type=script&lang=js"
export * from "./GroupMemberBar.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberBar.vue?vue&type=style&index=0&id=7d8268a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8268a4",
  null
  
)

export default component.exports